import { render, staticRenderFns } from "./MarketingServicesValues.vue?vue&type=template&id=ee71a368&"
import script from "./MarketingServicesValues.vue?vue&type=script&lang=js&"
export * from "./MarketingServicesValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports